import First from "../../../../../assets/images/project/rumah/TRA_HOUSE/tarra-house.jpg";

export default [
  {
    title: "Villa House",
    description: "Rumah villa modern minimalis",
    urls: First,
  },
];
